import React from 'react'
import style from './EquipmentMetalworking.module.css'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ScrollArrow } from '../../../Components/ScrollArrow/ScrollArrow'

const EquipmentMetalworking = () => {
  const { t } = useTranslation()
  return (
    <div className={style.engineering} id={'metal'}>
      <div className={`${'customContainer'} ${style.engineering_wrap}`}>
        <h2 className={style.title}>{t('equipmentMetalworking.title')}</h2>
        <p className={style.desc}>{t('equipmentMetalworking.desc')}</p>
        <Link to={'/engineering/metalworking'} className={style.button}>
          {t('equipmentThermoplastics.button')}
        </Link>
        <div className={style.block_arrow}>
          <ScrollArrow />
        </div>
      </div>
    </div>
  )
}

export default EquipmentMetalworking
